import React from "react";
import PropTypes from "prop-types";
import { graphql } from "gatsby";

import { Container } from "@material-ui/core";
import SectionHead from "../components/section-head";
import ReadMore from "../components/read-more";
import CornerPageTop from "../components/corner-page-top";
import CornerPageLinks from "../components/corner-page-links";
import Breadcrumb from "../components/bread";
import PostFilter from "../components/post-filter";
import PostFeed from "../components/post-feed";
import HurtigNav from "../components/hurtig-nav";
import LinksIcons from "../components/links-icons";
import LinksList from "../components/links-list";
import Cf7Contact from "../components/cf7-contact";
import Cf7Career from "../components/cf7-career";
import LogoFeed from "../components/logo-feed";
import Hero2 from "../components/hero-2";
import CaseHeader from "../components/case-header";
import CareerHeader from "../components/career-header";
import Header from "../components/header";
import Footer from "../components/footer";
import ContactAnsatt from "../components/contact-ansatt";
import SingleLink from "../components/single-link";
import ImgGallery4 from "../components/img-gallery-4";
import InfoGrid from "../components/info-grid";
import AdviceCard from "../components/advice-card";
import Banner from "../components/banner";
import ToolsList from "../components/tools-list";
import ShortcutLinks from "../components/shortcut-link-list";
import SectionTop from "../components/section-top";
import CustomQuote from "../components/custom-quote";
import Columns from "../components/columns";
import Column from "../components/column";
import ImageLibpixel from "../components/image-libpixel.js";
import Cover from "./cover-block";
import Button from "./button";
import GutenbergBlocks from "./gutenberg-blocks";
import RoundIconLink from "./round-icon-link";
import Video from "./video";
import Image from "./image";

const GutenbergBlock = ({ block, posts, post }) => {
  switch (block.name) {
    case "core/button":
      return (
        <Button
          variant={
            block.attributes.className === "is-style-outline"
              ? "secondary"
              : "primary"
          }
          label={block.attributes.text}
          target={block.attributes.linkTarget}
          rel={block.attributes.rel}
          url={block.attributes.url?.replace(
            process.env.GATSBY_WORDPRESS_URL,
            ""
          )}
          innerClassName={block.attributes.className}
          backgroundColor={
            block.attributes?.backgroundColorHex ||
            block.attributes?.backgroundColor
          }
          textColor={
            block.attributes?.textColorHex || block.attributes?.textColor
          }
        />
      );
    case "mev/icon-button":
      return (
        <RoundIconLink
          link={block.attributes?.url}
          textcolor={block.attributes?.textColorHex}
          bgColor={block.attributes?.backgroundColorHex}
          fontsize={block.attributes?.parsedFontSize}
          icon={
            block.attributes?.iconJSON
              ? JSON.parse(block.attributes.iconJSON)
              : undefined
          }
          padding={block.attributes?.padding}
        />
      );

    case "core/buttons":
      return (
        <div
          className="button-container"
          style={{
            justifyContent:
              block.attributes?.contentJustification || "flex-start",
          }}
        >
          <GutenbergBlocks blocks={block.innerBlocks} />
        </div>
      );
    case "contact-form-7/contact-form-selector": {
      switch (block.attributes?.formTemplate) {
        case "contact": {
          return <Cf7Contact url={block.attributes.url} />;
        }
        case "career": {
          return <Cf7Career url={block.attributes.url} />;
        }
      }
      return null;
    }
    case "core/paragraph":
      return block.saveContent.includes("has-small-font-size") ? (
        <p
          className="core-paragraph"
          style={{
            color: block.attributes.textColorHex || block.attributes.textColor,
            textAlign: block.saveContent.includes("has-text-align-center")
              ? "center"
              : block.saveContent.includes("has-text-align-right")
              ? "right"
              : "left",
          }}
          dangerouslySetInnerHTML={{
            __html: block.saveContent
              .replace(/(<p[^>]+?>|<p>|<\/p>)/gim, "")
              .replace("https://localhost:8000", "")
              .replace("https://enkle.re/MEV-DEV", "")
              .replace("http://localhost:8000", "")
              .replace("http://enkle.re/MEV-DEV", ""),
          }}
        />
      ) : (
        <p
          style={{
            color: block.attributes.textColorHex || block.attributes.textColor,
            textAlign: block.saveContent.includes("has-text-align-center")
              ? "center"
              : block.saveContent.includes("has-text-align-right")
              ? "right"
              : "left",
          }}
          itemProp="articleBody"
          className="block-paragraph"
          dangerouslySetInnerHTML={{
            __html: block.saveContent
              .replace(/(<p[^>]+?>|<p>|<\/p>)/gim, "")
              .replace("https://localhost:8000", "")
              .replace("https://enkle.re/MEV-DEV", "")
              .replace("http://localhost:8000", "")
              .replace("http://enkle.re/MEV-DEV", ""),
          }}
        />
      );
    case "core/list":
      return (
        <div
          itemProp="articleBody"
          className="block-paragraph"
          dangerouslySetInnerHTML={{
            __html: block.saveContent.replace(/(<p[^>]+?>|<p>|<\/p>)/gim, ""),
          }}
        />
      );
    case "core/heading":
      return block.saveContent.includes("<h1") ? (
        <SectionHead
          id={block.attributes.anchor || ""}
          title={block.saveContent
            .replace("&amp;", "&")
            .replace(/(<([^>]+)>)/gi, "")
            .replace(/(<p[^>]+?>|<p>|<\/p>)/gim, "")}
          isCentered={
            block.saveContent.includes("has-text-align-center") && true
          }
        />
      ) : block.saveContent.includes("h2") ? (
        <h2
          id={block.attributes.anchor || "headline-1"}
          className={(`block-headline`, `special-heading-mobile`)}
          style={{
            fontSize: "2rem",
            margin: "5px 0",
            color:
              block.attributes?.textColorHex || block.attributes?.textColor,
            textAlign:
              block.saveContent.includes("has-text-align-center") && true
                ? "center"
                : "left",
          }}
        >
          {block.saveContent
            .replace("&amp;", "&")
            .replace(/(<([^>]+)>)/gi, "")
            .replace(/(<p[^>]+?>|<p>|<\/p>)/gim, "")}
        </h2>
      ) : block.saveContent.includes("h3") ? (
        <h3
          id={block.attributes.anchor || "headline-1"}
          className={`block-headline`}
          style={{
            fontSize: "1.4rem",
            margin: "5px 0",
            color:
              block.attributes?.textColorHex || block.attributes?.textColor,
          }}
        >
          {block.saveContent
            .replace("&amp;", "&")
            .replace(/(<([^>]+)>)/gi, "")
            .replace(/(<p[^>]+?>|<p>|<\/p>)/gim, "")}
        </h3>
      ) : block.saveContent.includes("h4") ? (
        <h4
          id={block.attributes.anchor || "headline-1"}
          className={`block-headline`}
          style={{
            color:
              block.attributes?.textColorHex || block.attributes?.textColor,
          }}
        >
          {block.saveContent
            .replace("&amp;", "&")
            .replace(/(<([^>]+)>)/gi, "")
            .replace(/(<p[^>]+?>|<p>|<\/p>)/gim, "")}
        </h4>
      ) : block.saveContent.includes("h5") ? (
        <h5
          id={block.attributes.anchor || "headline-1"}
          className={`block-headline`}
          style={{
            color:
              block.attributes?.textColorHex || block.attributes?.textColor,
          }}
        >
          {block.saveContent
            .replace("&amp;", "&")
            .replace(/(<([^>]+)>)/gi, "")
            .replace(/(<p[^>]+?>|<p>|<\/p>)/gim, "")}
        </h5>
      ) : block.attributes.className === "h1" ? (
        <SectionHead
          id={block.attributes.anchor || ""}
          type="h2"
          title={block.saveContent
            .replace("&amp;", "&")
            .replace(/(<([^>]+)>)/gi, "")
            .replace(/(<p[^>]+?>|<p>|<\/p>)/gim, "")}
          isCentered={
            block.saveContent.includes("has-text-align-center") && true
          }
        />
      ) : (
        <h2
          id={block.attributes.anchor || "headline-1"}
          className={`block-headline`}
          style={{
            fontSize: "1.9rem",
            lineHeight: "2.5rem",
            margin: 0,
            padding: "10px 0 5px 0",
            color:
              block.attributes?.textColorHex || block.attributes?.textColor,
          }}
        >
          {block.saveContent
            .replace("&amp;", "&")
            .replace(/(<([^>]+)>)/gi, "")
            .replace(/(<p[^>]+?>|<p>|<\/p>)/gim, "")}
        </h2>
      );
    case "core/cover":
      return (
        <Cover
          minHeight={block.attributes?.minHeight}
          minHeightUnit={block.attributes?.minHeightUnit}
          align={block.attributes?.align}
          imgSrc={block.attributes?.url}
          dimRatio={block.attributes?.dimRatio}
          overlayColor={block.attributes?.customOverlayColor}
        >
          {block.innerBlocks &&
            block.innerBlocks.map((subBlock, j) => (
              <div key={j} data-block={subBlock.name}>
                <GutenbergBlock block={subBlock} posts={posts} post={post} />
              </div>
            ))}
        </Cover>
      );
    case "core/video":
      return (
        <Video
          align={block.attributes.align}
          preload={block.attributes.preload}
          poster={block.attributes.poster}
          src={block.attributes.src}
        />
      );
    case "acf/testimonial":
      return <div>{block.name}</div>;
    case "acf/feed":
      return (
        <PostFeed
          categories={block.acfFeed?.categories}
          fixedPosts={block.acfFeed?.fixedPosts}
          postsPerPage={block.acfFeed?.postsPerPage}
          showDate={block.acfFeed?.showDate}
          type={block.acfFeed?.type}
        />
      );
    case "acf/product-calculator":
      return <div>{block.name}</div>;
    case "acf/post-card":
      return <div>{block.name}</div>;
    case "acf/hero":
      return (
        <Hero2
          description={
            block.acfHero?.description
              ? block.acfHero?.description
              : "På karriere-siden vår finner du til enhver tid de stillingene vi har utlyst. Selv om vi ikke skulle ha en aktiv stillingsutslysning innenfor akkurat ditt fagfelt, betyr ikke det at vi ikke vil snakke med deg."
          }
          heroLayout={block.acfHero?.changeHeroLayout}
          imgSrc={
            block.acfHero.img?.sourceUrl
              ? block.acfHero.img?.sourceUrl
              : "https://static.enklerevalg.no/2022/06/produksjon-mev-enklerevalg-1024x524-1.jpeg"
          }
          links={block.acfHero?.links}
          textColor={
            block.acfHero?.chooseTextColor
              ? block.acfHero?.chooseTextColor
              : "#000"
          }
          title={
            block.acfHero?.title
              ? block.acfHero?.title
              : "Har du lyst å bli en del av flokken?"
          }
        />
      );
    case "acf/product-list":
      return <div>{block.name}</div>;
    case "acf/image": {
      return block.acfImage?.img?.sourceUrl ? (
        <ImageLibpixel
          src={block.acfImage.img.sourceUrl}
          itemProp="image"
          alt={block.acfImage?.imgCaption || block.acfImage.img?.altText}
          mode="fit"
          style={{ width: "100%", height: "100%" }}
        />
      ) : (
        <ImageLibpixel
          src="https://static.enklerevalg.no/2022/02/mask-group-23.png"
          itemProp="image"
          alt={block.acfImage?.imgCaption || block.acfImage.img?.altText}
          mode="fit"
          style={{ width: "100%", height: "100%" }}
        />
      );
    }
    case "acf/ingress":
      return <div>{block.name}</div>;
    case "acf/product-stats":
      return <div>{block.name}</div>;
    case "acf/product-gallery":
      return <div>{block.name}</div>;
    case "acf/product-addons":
      return <div>{block.name}</div>;
    case "acf/link":
      return (
        <SingleLink
          title={block.acfLink?.title}
          type={block.acfLink?.type}
          url={block.acfLink?.url}
        />
      );
    case "acf/links":
      return <div>{block.name}</div>;
    case "acf/form-image":
      return <div>{block.name}</div>;
    case "acf/filter":
      return (
        <PostFilter
          input={block.acfFilter?.input}
          title={block.acfFilter?.title}
          type={block.acfFilter?.type}
        />
      );
    case "acf/cf7-reklamasjon":
      return <div>{block.name}</div>;
    case "acf/info":
      return <div>{block.name}</div>;
    case "acf/faq":
      return <div>{block.name}</div>;
    case "acf/process":
      return <div>{block.name}</div>;
    case "acf/video":
      return <div>{block.name}</div>;
    case "acf/featured-product":
      return <div>{block.name}</div>;
    case "acf/featured-person":
      return <div>{block.name}</div>;
    case "acf/featured-post":
      return (
        <ReadMore
          uri={block.acfFeaturedPost?.addons?.uri}
          title={block.acfFeaturedPost?.addons?.title}
        />
      );
    case "acf/img-gallery":
      return <div>{block.name}</div>;
    case "acf/ul-list":
      return (
        <AdviceCard
          title={block.acfUlList?.title}
          color={block.acfUlList?.color}
        >
          {block.acfUlList?.content}
        </AdviceCard>
      );
    case "acf/img-gallery-4":
      return <ImgGallery4 imgs={block.acfImgGallery4?.imgs} />;
    case "acf/header-transparent":
      return (
        <Header
          siteTitle="{data.site.siteMetadata.title}"
          headerColor="frontpage"
        />
      );
    case "acf/header":
      return (
        <Header siteTitle="{data.site.siteMetadata.title}" headerColor="page" />
      );
    case "acf/footer":
      return <Footer />;
    case "acf/sidemenu":
      return <HurtigNav />;
    case "acf/highlight-stats":
      return <div>{block.name}</div>;
    case "acf/links-icons":
      return <LinksIcons links={block.acfLinksIcons?.links} />;
    case "acf/links-list":
      return (
        <LinksList
          backgroundColor={block.acfLinksList?.backgroundColor}
          columns={block.acfLinksList?.columns}
        />
      );
    case "acf/cf7-contact":
      return <Cf7Contact />;
    case "acf/cf7-career":
      return <Cf7Career />;
    case "acf/logo-feed":
      return <LogoFeed categories={block.acfLogoFeed?.category} />;
    case "acf/corner-page-header":
      return (
        <CornerPageTop post={post} links={block.acfCornerPageHeader?.links} />
      );
    case "acf/corner-page-links":
      return (
        <CornerPageLinks
          links={block.acfCornerPageLinks?.links?.map((link) => link.addons)}
        />
      );
    case "acf/corner-page-ingress":
      return (
        block.acfCornerPageIngress?.content && (
          <p
            className="block-ingress"
            dangerouslySetInnerHTML={{
              __html: block.acfCornerPageIngress.content.replace(
                /(<p[^>]+?>|<p>|<\/p>)/gim,
                ""
              ),
            }}
          />
        )
      );
    case "acf/breadcrumbs":
      return <Breadcrumb className={block.attributes?.className} post={post} />;
    case "acf/case-header":
      return (
        <CaseHeader
          post={post}
          title={block.acfCaseHeader?.title}
          dateFrom={block.acfCaseHeader?.dateFrom}
          dateTo={block.acfCaseHeader?.dateTo}
        />
      );
    case "acf/career-header":
      return (
        <CareerHeader
          post={post}
          dateTo={block.blockCareerHeader?.dateTo}
          dateFrom={block.blockCareerHeader?.dateFrom}
          subtitle={block.blockCareerHeader?.subtitle}
        />
      );
    case "acf/contact-ansatt-list":
      return <ContactAnsatt />;
    case "acf/info-grid":
      return <InfoGrid data={block.acfInfoGrid} />;
    case "acf/banner":
      return (
        <Banner
          columns={block.acfBanner?.columns}
          imgUrl={block.acfBanner?.img?.sourceUrl}
          imgAlt={block.acfBanner?.img?.altText}
          txtWhite={block.acfBanner?.color !== "black"}
        />
      );
    case "acf/custom-quote":
      return (
        <CustomQuote
          title={block.acfCustomQuote?.title}
          img={block.acfCustomQuote?.img?.sourceUrl}
          content={block.acfCustomQuote?.content}
        />
      );
    case "acf/tools-list":
      return <ToolsList columns={block.acfToolsList?.columns} />;
    case "acf/shortcut-links":
      return <ShortcutLinks columns={block.acfShortcutLinks?.columns} />;
    case "acf/section-top":
      return (
        <SectionTop
          title={block.acfSectionTop?.title}
          imgUrl={block.acfSectionTop?.img?.sourceUrl}
          content={block.acfSectionTop?.content?.replace(/\r\n/g, "\r\n<br>")}
        />
      );
    case "core/columns":
      return block.innerBlocks?.[0]?.innerBlocks?.[0]?.name ===
        "acf/sidemenu" ? (
        <div className="two-col-container" style={{ position: "relative" }}>
          {block.innerBlocks &&
            block.innerBlocks.map(
              (subBlock, k) =>
                subBlock.name === "core/column" && (
                  <div
                    key={k}
                    data-block={subBlock.name}
                    className={k === 0 ? "left-column" : "body-text"}
                    id={k === 0 ? "nav-fixed" : ""}
                  >
                    {subBlock.innerBlocks &&
                      subBlock.innerBlocks.map((subsubBlock, l) => (
                        <div key={l} data-block={subsubBlock.name}>
                          <GutenbergBlock
                            block={subsubBlock}
                            posts={posts}
                            post={post}
                          />
                        </div>
                      ))}
                  </div>
                )
            )}
        </div>
      ) : (
        <Container
          maxWidth={
            block.attributes.className.includes("xl")
              ? "xl"
              : block.attributes.className.includes("md")
              ? "md"
              : "lg"
          }
          className="disable-padding"
        >
          <Columns
            style={{
              gap: block.attributes.className.includes("no-gap")
                ? "0"
                : "1.5rem",
            }}
          >
            {block.innerBlocks &&
              block.innerBlocks.map((subBlock, k) => (
                <Column
                  key={k}
                  name={subBlock.name}
                  align={subBlock.attributes?.verticalAlignment}
                  backgroundColor={subBlock.attributes?.backgroundColorHex}
                  textColor={subBlock.attributes?.textColorHex}
                  extraPadding={
                    subBlock.attributes?.className.includes("extra-padding")
                      ? true
                      : false
                  }
                >
                  {subBlock.innerBlocks &&
                    subBlock.innerBlocks.map((subsubBlock, l) => (
                      <div key={l} data-block={subsubBlock.name}>
                        <GutenbergBlock
                          block={subsubBlock}
                          posts={posts}
                          post={post}
                        />
                      </div>
                    ))}
                </Column>
              ))}
          </Columns>
        </Container>
      );
    case "core/group":
      return (
        <Container
          maxWidth={
            block.attributes.className === "xl"
              ? "xl"
              : block.attributes.className === "md"
              ? "md"
              : "lg"
          }
          className="disable-padding"
        >
          {block.innerBlocks &&
            block.innerBlocks.map((subBlock, j) => (
              <div key={j} data-block={subBlock.name}>
                <GutenbergBlock block={subBlock} posts={posts} post={post} />
              </div>
            ))}
        </Container>
      );

    case "core/image": {
      const maxWidth = ((size) => {
        switch (size) {
          case "full":
            return "xl";
          case "thumbnail":
            return "xs";
          case "medium":
            return "sm";
          case "large":
          default:
            return "md";
        }
      })(block.attributes.sizeSlug);
      return (
        <Container
          maxWidth={maxWidth}
          disableMargin={true}
          disableGutters={true}
          className={block.attributes.className}
          textColor={block.attributes?.customTextColor}
          backgroundColor={block.attributes?.backgroundColor}
        >
          {block?.attributes?.href !== "" ? (
            <a
              href={block.attributes.href}
              target={block?.attributes?.rel === "noopener" ? "_blank" : ""}
              rel={"noreferrer"}
            >
              <Image
                image={block.attributes.url}
                className={`img-width ${block.attributes.className}`}
                alt={block.attributes.alt}
                src={block.attributes.url}
              />
            </a>
          ) : (
            <Image
              image={block.attributes.url}
              className={`img-width ${block.attributes.className}`}
              alt={block.attributes.alt}
              src={block.attributes.url}
            />
          )}
          {block.attributes.caption && (
            <p
              className="center"
              dangerouslySetInnerHTML={{ __html: block.attributes.caption }}
            />
          )}
        </Container>
      );
    }

    case "core/spacer":
      return (
        <div
          style={{ display: "contents" }}
          dangerouslySetInnerHTML={{ __html: block.saveContent }}
        />
      );
    default:
      return block.name;
  }
};

export default GutenbergBlock;

GutenbergBlock.propTypes = {
  block: PropTypes.object.isRequired,
  posts: PropTypes.object.isRequired,
  post: PropTypes.object.isRequired,
};

export const query = graphql`
  fragment PostObjectBasicInfo on WpPostObjectUnion {
    ... on WpCase {
      title
      uri
    }
    ... on WpEmployee {
      title
      uri
    }
    ... on WpPage {
      title
      uri
    }
    ... on WpPost {
      title
      uri
    }
    ... on WpService {
      title
      uri
    }
  }

  fragment GutenbergBlock on WpBlock {
    name
    saveContent
    ... on WpAcfBreadcrumbsBlock {
      attributes {
        className
      }
    }
    ... on WpAcfHeroBlock {
      acfHero {
        changeHeroLayout
        chooseTextColor
        description
        links {
          link {
            title
            url
          }
          linkTitle
        }
        img {
          sourceUrl
        }
        title
      }
    }

    ... on WpAcfFeedBlock {
      acfFeed {
        categories {
          databaseId
        }
        fixedPosts {
          ... on WpPage {
            databaseId
          }
          ... on WpPost {
            databaseId
          }
        }
        postsPerPage
        showDate
        type
        title
      }
    }

    ... on WpAcfFilterBlock {
      acfFilter {
        input
        title
        type
      }
    }

    ... on WpAcfImageBlock {
      acfImage {
        img {
          altText
          sourceUrl
        }
        imgCaption
      }
    }

    ... on WpAcfLinkBlock {
      acfLink {
        title
        type
        url
      }
    }

    ... on WpAcfLinksIconsBlock {
      acfLinksIcons {
        links {
          description
          img {
            sourceUrl
          }
          link {
            ...PostObjectBasicInfo
          }
        }
      }
    }

    ... on WpAcfLinksListBlock {
      acfLinksList {
        backgroundColor
        columns {
          links {
            ...PostObjectBasicInfo
          }
          title
        }
      }
    }

    ... on WpAcfCustomQuoteBlock {
      acfCustomQuote {
        content
        title
        img {
          sourceUrl
        }
      }
    }

    ... on WpAcfUlListBlock {
      acfUlList {
        content
        color
        title
      }
    }

    ... on WpAcfCareerHeaderBlock {
      blockCareerHeader {
        dateFrom
        dateTo
        subtitle
      }
    }

    ... on WpAcfInfoGridBlock {
      acfInfoGrid {
        items {
          text
          title
          img {
            sourceUrl
          }
        }
      }
    }

    ... on WpAcfLogoFeedBlock {
      acfLogoFeed {
        category {
          acfCategoryThumbnail {
            img {
              sourceUrl
            }
          }
        }
      }
    }

    ... on WpAcfFeaturedPostBlock {
      acfFeaturedPost {
        addons {
          ...PostObjectBasicInfo
        }
      }
    }

    ... on WpAcfCornerPageHeaderBlock {
      acfCornerPageHeader {
        links {
          img {
            sourceUrl
          }
          title
          url
        }
      }
    }

    ... on WpAcfCornerPageLinksBlock {
      acfCornerPageLinks {
        links {
          addons {
            ...PostObjectBasicInfo
          }
        }
      }
    }

    ... on WpAcfCornerPageIngressBlock {
      acfCornerPageIngress {
        content
      }
    }

    ... on WpAcfCaseHeaderBlock {
      acfCaseHeader {
        dateFrom
        dateTo
        title: subtitle
      }
    }
    ... on WpAcfBannerBlock {
      acfBanner {
        color
        img {
          sourceUrl
          altText
        }
        columns {
          text
          title
          img {
            altText
            sourceUrl
          }
        }
      }
    }
    ... on WpAcfToolsListBlock {
      acfToolsList {
        columns {
          text
          title
          img {
            sourceUrl
          }
        }
      }
    }

    ... on WpAcfSectionTopBlock {
      acfSectionTop {
        content
        title
        img {
          sourceUrl
        }
      }
    }

    ... on WpAcfShortcutLinksBlock {
      acfShortcutLinks {
        columns {
          text
          title
          links {
            ...PostObjectBasicInfo
          }
          img {
            sourceUrl
          }
        }
      }
    }

    ... on WpAcfImgGallery4Block {
      acfImgGallery4 {
        imgs {
          img {
            sourceUrl
          }
        }
      }
    }

    ... on WpCoreButtonsBlock {
      attributes {
        ... on WpCoreButtonsBlockAttributes {
          contentJustification
        }
      }
    }

    ... on WpCoreButtonBlock {
      attributes {
        ... on WpCoreButtonBlockAttributes {
          text
          className
          url
          linkTarget
          rel
          className
          backgroundColorHex
          textColorHex
          backgroundColor
          textColor
        }
      }
    }
    ... on WpMevIconButtonBlock {
      attributes {
        url
        textColorHex
        parsedFontSize
        padding
        iconJSON
        backgroundColorHex
      }
    }
    ... on WpContactForm7ContactFormSelectorBlock {
      attributes {
        ... on WpContactForm7ContactFormSelectorBlockAttributes {
          url
          formTemplate
        }
      }
    }

    ... on WpCoreGroupBlock {
      attributes {
        ... on WpCoreGroupBlockAttributes {
          className
        }
      }
    }

    ... on WpCoreHeadingBlock {
      attributes {
        ... on WpCoreHeadingBlockAttributes {
          className
          textColorHex
          textColor
          anchor
        }
      }
      saveContent
    }

    ... on WpCoreColumnsBlock {
      attributes {
        ... on WpCoreColumnsBlockAttributes {
          verticalAlignment
          className
        }
      }
    }

    ... on WpCoreColumnBlock {
      attributes {
        ... on WpCoreColumnBlockAttributes {
          verticalAlignment
          backgroundColorHex
          textColorHex
          textColor
          className
        }
      }
    }

    ... on WpCoreParagraphBlock {
      attributes {
        ... on WpCoreParagraphBlockAttributes {
          textColorHex
          textColor
          className
        }
      }
    }

    ... on WpCoreSpacerBlock {
      saveContent
    }

    ... on WpCoreCoverBlock {
      attributes {
        ... on WpCoreCoverBlockAttributes {
          align
          customOverlayColor
          dimRatio
          url
          minHeight
          minHeightUnit
        }
      }
    }
    ... on WpCoreVideoBlock {
      attributes {
        ... on WpCoreVideoBlockAttributes {
          autoplay
          src
          controls
          playsInline
          align
          muted
          loop
          poster
          preload
        }
      }
    }

    ... on WpCoreImageBlock {
      attributes {
        ... on WpCoreImageBlockAttributes {
          id
          alt
          url
          anchor
          align
          caption
          className
          height
          href
          linkClass
          linkDestination
          linkTarget
          # lock
          rel
          sizeSlug
          title
          # style
          width
        }
      }
    }
  }
  fragment GutenbergBlocks on WpBlock {
    ...GutenbergBlock
    innerBlocks {
      ...GutenbergBlock
      innerBlocks {
        ...GutenbergBlock
        innerBlocks {
          ...GutenbergBlock
          innerBlocks {
            ...GutenbergBlock
            innerBlocks {
              ...GutenbergBlock
              innerBlocks {
                ...GutenbergBlock
              }
            }
          }
        }
      }
    }
  }
`;
